import "./DeliveryPictureElement.less";
import { MediaViewerElement } from './MediaViewerElement';

export class DeliveryPictureElement extends HTMLElement { 
    static tag = "delivery-picture";

    connectedCallback() { 
        this.innerHTML = this.view();
        this.querySelector("img").addEventListener("load", this.onLoad);
        this.addEventListener("pointerdown", this.showImage);
    }

    private onLoad = () => { 
        this.querySelector("div").remove();
    }

    private view = () => `
        <div></div>
        <img src="${this.getAttribute("source")}">
    `

    private showImage = () => { 
        const mediaViewer = new MediaViewerElement();
        mediaViewer.setAttribute("scaled-url", this.getAttribute("source"));
        mediaViewer.setAttribute("original-url", this.getAttribute("original-source"));
        this.parentElement.appendChild(mediaViewer);
    }
}

customElements.define(DeliveryPictureElement.tag, DeliveryPictureElement);